<ispui-tooltip
  disabledArrow
  tooltip-class="isp-field-base-tag-hint-tooltip"
  [title-text]="tagData.hintText || ''"
  [placement-order]="['right', 'topRight', 'bottomLeft', 'bottomRight']"
  [attach-selector]="hintAttachContainer | formIdPrefix"
  [scroll-selector]="hintAttachContainer | formIdPrefix"
>
  <div
    class="tag"
    [ngClass]="{
      tag_blue: tagData.color === 'blue',
      tag_grey: tagData.color === 'grey',
      tag_hoverable: tagData.hintText
    }"
  >
    {{ tagData.text }}

    <isp-svg-icon
      *ngIf="tagData.hintText"
      name="p-info"
      size="15px"
    ></isp-svg-icon>
  </div>
</ispui-tooltip>

<div *ngIf="tagData.price" class="price">
  <div
    [innerHTML]="
      tagData.price.percent
        | percent
          : {
              color: 'green',
              sign: 'negative',
              bold: true
            }
    "
  ></div>
  <div
    [innerHTML]="
      tagData.price.oldCost
        | cost
          : {
              smallFraction: false,
              currency: tagData.price.currency,
              crossed: true,
              color: 'grey'
            }
    "
  ></div>
</div>
